import { useSessionContext } from "@supabase/auth-helpers-react";
import { useEffect, useState } from "react";
import { UserProfileContext } from "./UserContext";
import { getUserProfile } from "../../services/profile/profile.api";
import { supabase } from "../../common/config/supabase";
import LoadingContent from "../../components/LoadingContent";
import { IProfile } from "../../common/interfaces/profile.interface";

export const UserContextProvider = ({ children }: {children: JSX.Element} ) => {
    const session = useSessionContext();
    const [loading, setLoading] = useState<boolean>(true);
    const [profile, setProfile] = useState<IProfile | null>(null);
    const [isAuthenticated, setIsAuthenticated] = useState<boolean>(false);

    useEffect(() => {
        const getUser = async () => {
            if (session?.session?.user.id && !profile) {
                const data = await getUserProfile(session?.session?.user.id);
                if (data) {
                    setIsAuthenticated(true);
                    setProfile(data);
                } else {
                    setIsAuthenticated(false);
                    await supabase.auth.signOut();
                }
                setLoading(false);
            }

            if (!session.isLoading && !session.session) {
                setLoading(false);
            }
        }

        getUser();
    }, [session])

    return (
        <UserProfileContext.Provider value={{ user: profile, isAuthenticated, isLoading: loading || session.isLoading }}>
            {loading || session.isLoading ? <LoadingContent /> : children}
        </UserProfileContext.Provider>
    );
}